import { useState, useEffect } from 'react';
import { CountDownTickerInterface } from './CountDownTicker';

interface useCountDownTickerReturnValue {
	active: boolean;
	currentTime: number;
}

export const useCountDownTicker = ({ time, action }: CountDownTickerInterface): useCountDownTickerReturnValue => {
	const [currentTime, setCurrentTime] = useState(time);
	const [active, setActive] = useState(false);

	useEffect(() => {
		if (time > 0) {
			setActive(true);
			setCurrentTime(time);
		} else {
			setActive(false);
		}
	}, [time, active]);

	useEffect(() => {
		const ticker = setInterval(() => setCurrentTime(currentTime - 1), 1000);

		if (!currentTime) {
			clearInterval(ticker);
			active && action();
		}

		return () => ticker && clearInterval(ticker);
	}, [currentTime, active, action]);

	return { currentTime, active };
};
